<template lang="pug">
.article-block-inner(:style="{position: 'relative'}" :key="`articlewrapper-${this.payload.sys.id}`")
  parallax(:animationTarget="['position', 'opacity']" :overflow="false" :key="`main-${this.payload.sys.id}`")
    article(:id="`container-${this._uid}`" :class="`${this.payload.fields.templateId} ${this.classes}`")
      image-block(
        v-if="!!this.image && this.classes.match('image-left') || !!this.image && this.classes.match('image-behind')"
        :payload="this.image")
      div.article-content.content
        h1.section-title {{this.title}}
        vue-markdown.desc(:source='this.desc')
        div(v-if="this.payload.fields.linkLabel")
          router-link.button.minimal(v-if="!this.payload.fields.link.match('http')" :to="{ name: 'pageScene', params: { page: this.payload.fields.link }}") {{ this.payload.fields.linkLabel }}
          a(v-if="this.payload.fields.linkLabel && this.payload.fields.link.match('http')" class="button minimal" :href="this.payload.fields.link") {{ this.payload.fields.linkLabel }}

      image-block(
        v-if="!!this.image && this.classes.match('image-right')"
        :payload="this.image")

  parallax.sub-articles(
    :key="this.payload.sys.id"
    direction="down"
    :speedFactor="1"
    :animationTarget="['position']"
    :animateOut="true"
    :delay="-740"
    :update="false"
    :fixed="`${(this.content.length + 1) * (400)}`"
    v-if="matchesSpecialClass && this.content.length > 0"
    :style="{position: 'relative', marginTop: '-150px'}")

    div.progressBar
      parallax.nodeContainer(
        v-for="(n,i) in this.content"
        :key="n.sys.id + 'node'"
        :animationTarget="['opacity']"
        :animateIn="i !== 0"
        :delay="(i === 0 ? (250 * i) : (300 * i))"
        :update="false"
        :speedFactor=".3"
        )
        div.node

    parallax.parallax-article(:style="{zIndex: `${(6 - i)}` }"
      v-for="(n, i) in this.content"
      :key="n.sys.id"
      :animationTarget="['opacity']"
      :animateIn="i !== 0"
      :animateOut="i !== content.length"
      :delay="(i === 0 ? (250 * i) : (380 * i))"
      :update="false"
      :speedFactor=".3")
      article.item.subarticle.row(style="padding-top: 150px" :class="`${classes}`")
        image-block(
          v-if="!!n.fields.image && classes.match('image-left') || !!n.fields.image && classes.match('image-behind')"
          :payload="n.fields.image"
          :style="{position: absolute, top: '150px', right: 0}")
        div.article-content.content
          h3.section-title {{n.fields.title}}
          vue-markdown.desc(:source='n.fields.desc || n.fields.body')
        image-block(
          v-if="!!n.fields.image && classes.match('image-right')"
          :payload="n.fields.image"
          :style="{marginTop: '50px'}")

  .sub-articles(
    :key="this.payload.sys.id"
    v-if="!matchesSpecialClass && this.content.length > 0"
    :style="{position: 'relative'}")
    article.item.subarticle.row(v-for="(n, i) in this.content" :class="`${classes}`")
      image-block(
        v-if="!!n.fields.image && classes.match('image-left') || !!n.fields.image && classes.match('image-behind')"
        :payload="n.fields.image"
        :style="{position: absolute, top: '150px', right: 0}")
      div.article-content.content
        h3.section-title {{n.fields.title}}
        vue-markdown.desc(:source='n.fields.desc || n.fields.body')
      image-block(
        v-if="!!n.fields.image && classes.match('image-right')"
        :payload="n.fields.image"
        :style="{marginTop: '50px'}")
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/_sectionBase.js'

// component instance
var articleBlock = Vue.component('article-block', {
  name: 'articleBlock',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
      parent: this.getParent()
    }
  },
  watch: {
  },
  methods: {
    getParent () {
      return this.$parent.$el
    }
  },
  computed: {
    matchesSpecialClass () {
      // used to determine if article-block nested content blocks should be rendered as parallax elements
      // COMBAK $el does not always seem to be defined at the moment this is called resulting in false
      // nontheless this is a bad way of doing this eitherway...
      // console.log(this.parent);
      // console.log(this.getParent().classList.contains('parallax-article-items'));
      // const matchClass = this.parent ? this.parent.classList.contains('parallax-article-items') : false
      return true
    }
  },
  created () {},
  mounted () {
    // console.log(this.$parent.$el.classList.contains('process-split-interactive'));
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default articleBlock
</script>

<style lang="scss" scoped>
.progressBar{
  position: absolute;
  top: measure(ml)
}
.node{
  z-index: 9999;
  width: 8px;
  height: 8px !important;
  background: get-color(secondary) !important;
  border-radius: 8px;
  margin: 2px
}
.nodeContainer{
  z-index: 9999;
  width: 14px;
  height: 14px !important;
  border-radius: 6px;

  margin: 0 0 #{measure(xxs) / 2} -#{measure(s)};
  border: 1px solid get-color(primary-min1);
}

.article-block{
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  align-items: center;

  padding-top: measure(s);

  @for $i from 1 through 5 {
    &.background-artifact-#{$i}{
      padding-top: 0vw;
    }
  }
}
  .content{
    @include breakpoint(small only) {
      flex: 0 0 100%;
    }
  }
  .section-title{
    flex: 0 0 100%;
  }

  .desc{

  }

  .image{
    // COMBAK: fix image sizing with iamge-width classes
    // transform: scale(1);
    align-self: flex-start;
    // margin-left: measure(sm);
    /* margin-top: -1rem; */
    @include breakpoint(small only) {
      flex: 0 0 100%;
      padding: measure(sm);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/articleBlock.vue